// start:ng42.barrel
export * from './base-model';
export * from './oktopost.interface';
export * from './files.interface';
export * from './general.interfaces';
export * from './angular-extras';
export * from './credentials.interfaces';
// end:ng42.barrel
